import { ExperienceColorMode } from '@/types/gql.generated';
import type { SegmentedOption } from './StylePanel/SegmentedControl';

// The card fill choice (colorMode) is a whole-schedule setting offered from two
// places — the Views panel alongside the card display type, and the Style panel
// over a gallery showing the palette at that fill strength — so the option list
// and the enum mapping live here.
export type CardColorMode = 'bold' | 'light';

export const CARD_COLOR_OPTIONS: SegmentedOption<CardColorMode>[] = [
  { label: 'Bold', value: 'bold' },
  { label: 'Light', value: 'light' },
];

export const toCardColorMode = (
  colorMode: ExperienceColorMode
): CardColorMode => (colorMode === ExperienceColorMode.Bold ? 'bold' : 'light');

export const toExperienceColorMode = (
  mode: CardColorMode
): ExperienceColorMode =>
  mode === 'bold' ? ExperienceColorMode.Bold : ExperienceColorMode.Light;
